import React from 'react';
import { useTheme } from '../styles/ThemeContext';
interface InteriorTopBarProps {
  onReset: () => void;
  onControls: () => void;
  onSettings: () => void;
  onExit: () => void;
}
export function InteriorTopBar({
  onReset,
  onControls,
  onSettings,
  onExit
}: InteriorTopBarProps) {
  const {
    isDark
  } = useTheme();
  return <div className={`absolute top-4 right-4 z-30 flex items-center gap-1 backdrop-blur-xl rounded-lg px-2 py-1.5 border shadow-lg transition-colors duration-300 ${isDark ? 'bg-slate-900/70 border-white/10' : 'bg-white/70 border-white/40'}`} data-id="element-309">
      <button onClick={onReset} className={`px-3 py-1.5 rounded text-sm uppercase tracking-wider transition-colors ${isDark ? 'text-slate-300 hover:text-white hover:bg-white/10' : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'}`} data-id="element-310">
        Reset
      </button>
      <div className={`w-px h-4 ${isDark ? 'bg-white/10' : 'bg-gray-300/50'}`} data-id="element-311" />
      <button onClick={onControls} className={`px-3 py-1.5 rounded text-sm uppercase tracking-wider transition-colors ${isDark ? 'text-slate-300 hover:text-white hover:bg-white/10' : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'}`} data-id="element-312">
        Controls
      </button>
      <div className={`w-px h-4 ${isDark ? 'bg-white/10' : 'bg-gray-300/50'}`} data-id="element-313" />
      <button onClick={onSettings} className={`px-3 py-1.5 rounded text-sm uppercase tracking-wider transition-colors ${isDark ? 'text-slate-300 hover:text-white hover:bg-white/10' : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'}`} data-id="element-314">
        Settings
      </button>
      <div className={`w-px h-4 ${isDark ? 'bg-white/10' : 'bg-gray-300/50'}`} data-id="element-315" />
      <button onClick={onExit} className={`px-3 py-1.5 rounded text-sm uppercase tracking-wider transition-colors ${isDark ? 'text-slate-300 hover:text-white hover:bg-white/10' : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'}`} data-id="element-316">
        Exit Model
      </button>
    </div>;
}